/** Same-app paths only. Protocol-relative values such as //other.example fall back to Home. */
export function getInternalReturnUrl(value: unknown): string {
  return typeof value === "string" && value.startsWith("/") && !value.startsWith("//") ? value : "/home";
}
